var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEffects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 216,
    y1: 128,
    x2: 216,
    y2: 176,
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 152,
    x2: 240,
    y2: 152,
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 40,
    x2: 80,
    y2: 88,
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 64,
    x2: 104,
    y2: 64,
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 184,
    x2: 168,
    y2: 216,
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 200,
    x2: 184,
    y2: 200,
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 144,
    y1: 80,
    x2: 176,
    y2: 112,
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.49,
    y: 105.37,
    width: 213.02,
    height: 45.25,
    rx: 8,
    transform: "translate(-53.02 128) rotate(-45)",
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffects);
export default __webpack_public_path__ + "static/media/effects.1589651395fca684363e594d13281758.svg";
export { ForwardRef as ReactComponent };